import React from 'react';
import PropTypes from 'prop-types';
import TailwindScope from '../Shared/TailwindScope';
import { observer } from 'mobx-react';
import InputField from '../Shared/Tailwind/InputField';
import cn from 'classnames';

const styles = {
  fullWidth: 'w-full',
  wrapper: 'w-full flex items-start justify-start',
  container: 'w-full ml-5',
  contactInfo: 'w-full p-2 text-md text-brand-navy',
  contentSpacing: 'w-full pb-2 pt-2 space-y-4',
  buttonContainer: 'w-full flex justify-between items-center gap-2 pt-4 mb-7',
  cancelButton:
    'w-full sm:w-40 h-10 bg-brand-gold rounded-3xl border-none text-white text-md font-bold font-sabs uppercase tracking-wide cursor-pointer hover:shadow-lg transition-shadow',
  saveButton:
    'w-full sm:w-40 h-10 bg-blue rounded-3xl border-none text-white text-md font-bold font-sans uppercase tracking-wide cursor-pointer hover:shadow-lg transition-shadow',
  fieldGroup: 'self-stretch flex flex-col items-start',
  fieldLabel: 'text-left text-blue-950 text-lg font-semibold leading-5',
  textArea: 'w-full min-h-28 px-3 py-2.5 rounded-sm outline outline-1 outline-offset-[-1px] outline-zinc-300',
};

const MeetingDiscussionDialog = observer((props) => {
  const { handleClose, saveForm, discussionNotes, setDiscussionNotes } = props;

  return (
    <>
      <TailwindScope className={cn(styles.fullWidth)} data-testid='award-payment-requests-summary-page'>
        <div className={cn(styles.wrapper)}>
          <div className={cn(styles.container)}>
            <div className={cn(styles.contentSpacing)}>
              <InputField
                name='meeting-item'
                label='Proactively document important topics, relevant items, and/or questions to be reviewed during the meeting.'
                type='textarea'
                value={discussionNotes}
                onChange={(event) => setDiscussionNotes(event.target.value)}
                placeholder='Type your meeting discussion item here.'
                wrapperClassName={styles.fieldGroup}
                labelClassName={styles.fieldLabel}
                inputClassName={styles.textArea}
                rows={10}
              />
            </div>
            <div className={cn(styles.buttonContainer)}>
              <button onClick={(event) => handleClose()} className={cn(styles.cancelButton)}>
                {'CANCEL'}
              </button>
              <button onClick={(event) => saveForm(discussionNotes)} className={cn(styles.saveButton)}>
                {'SAVE'}
              </button>
            </div>
          </div>
        </div>
      </TailwindScope>
      {/* {renderToast()} */}
    </>
  );
});

export default MeetingDiscussionDialog;

MeetingDiscussionDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  saveForm: PropTypes.func.isRequired,
  discussionNotes: PropTypes.string.isRequired,
  setDiscussionNotes: PropTypes.func.isRequired,
};
